import React from 'react';
import { ShieldAlert, CarFront, Trash2, Home, Heart, GraduationCap, Store, CalendarDays, HandHeart, MessageCircle } from 'lucide-react';
export function Categories() {
  const categories = [{
    title: 'Seguridad',
    description: 'Consulta recursos, reporta situaciones y encuentra canales oficiales para comunicar preocupaciones.',
    icon: ShieldAlert
  }, {
    title: 'Calles y tráfico',
    description: 'Revisa información sobre problemas de tránsito, señales, banquetas, iluminación, baches y movilidad.',
    icon: CarFront
  }, {
    title: 'Limpieza',
    description: 'Encuentra opciones para reportar basura, grafiti, escombros u otros problemas del espacio público.',
    icon: Trash2
  }, {
    title: 'Vivienda',
    description: 'Accede a recursos comunitarios relacionados con vivienda, apoyo local e información pública disponible.',
    icon: Home
  }, {
    title: 'Adultos mayores',
    description: 'Encuentra recursos, reuniones, contactos y servicios que pueden apoyar a personas mayores.',
    icon: Heart
  }, {
    title: 'Juventud',
    description: 'Conoce oportunidades para jóvenes, eventos, programas y formas de participación.',
    icon: GraduationCap
  }, {
    title: 'Negocios locales',
    description: 'Conecta con información comunitaria, reuniones, oportunidades y recursos para negocios del vecindario.',
    icon: Store
  }, {
    title: 'Eventos',
    description: 'Consulta actividades, reuniones, proyectos y fechas importantes para la comunidad.',
    icon: CalendarDays
  }, {
    title: 'Voluntariado',
    description: 'Descubre formas de ayudar, participar y apoyar proyectos locales.',
    icon: HandHeart
  }, {
    title: 'Contacto',
    description: 'Comunícate con el comité o encuentra el canal adecuado para tu solicitud.',
    icon: MessageCircle
  }];
  return <section className="py-24 px-6 lg:px-8 bg-white" data-id="element-39">
      <div className="max-w-7xl mx-auto" data-id="element-40">
        <div className="text-center mb-16" data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-42">
            ¿Qué necesitas resolver hoy?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-43">
            Selecciona una categoría y encuentra la información correcta más
            rápido.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6" data-id="element-44">
          {categories.map((category, index) => <a href={`#${category.title.toLowerCase().replace(/\s+/g, '-')}`} key={index} className="group flex flex-col bg-softblue/30 p-6 rounded-2xl border border-gray-100 hover:border-sky hover:bg-softblue transition-all duration-300 hover:-translate-y-1 hover:shadow-lg cursor-pointer" data-id="element-45">
              <div className="w-12 h-12 bg-charcoal/5 text-charcoal group-hover:bg-sky group-hover:text-white rounded-xl flex items-center justify-center mb-4 transition-colors" data-id="element-46">
                <category.icon className="w-6 h-6" data-id="element-47" />
              </div>
              <h3 className="text-lg font-bold text-charcoal mb-2 group-hover:text-sky-dark transition-colors" data-id="element-48">
                {category.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed flex-grow" data-id="element-49">
                {category.description}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}